import httpClient from '@/api/httpClient';

export const saveCart = (treatmentId, paymentInformation) =>
  httpClient.post(`/api/webShop/${treatmentId}/saveCart`, paymentInformation);

export const getSavedShippingAddressData = (treatmentId, addressType) =>
  httpClient.get(`/api/webShop/${treatmentId}/address/${addressType}/findPrevious`);

export const getPayfortTokenizationForm = treatmentId =>
  httpClient.post(`/payfort/tokenization?treatment_id=${treatmentId}`);

export const getPayfortTransactionStatus = treatmentId =>
  httpClient.get(`/payfort/auth?treatment_id=${treatmentId}`);

export const getTransactionStatus = treatmentId =>
  httpClient.get(`/api/webShop/paymentStatus?treatment_id=${treatmentId}`);

export const paypalCapture = ({ orderId, countryCode }) => {
  const params = new URLSearchParams({ countryCode });

  return httpClient.post(`/paypal/${orderId}/capture?${params}`);
};

export const getAvailablePaymentMethods = ({ countryCode, freeOrder }) => {
  const params = new URLSearchParams({ countryCode, freeOrder });

  return httpClient.get(`/api/webShop/paymentSystems?${params}`);
};
